(($) => {
  let TextColumnsSlider = () => {
    $('[data-block-text-columns-carousel] [data-columns]').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      dots: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 2480,
          settings: 'unslick'
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true
          }
        }
      ]
    });
  }

  $(document).ready(() => {
    console.log('READY');
    TextColumnsSlider();
  });
})(theme.jQuery);